import * as React from 'react';
import { StyleProp, View, ViewStyle, Text, StyleSheet } from 'react-native';
import Svg, {
  ClipPath,
  Defs,
  Ellipse,
  G,
  LinearGradient,
  Path,
  Rect,
  Stop,
} from 'react-native-svg';

const StreakBadge = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
    number?: number;
    numberFontSize?: number;
    topNumberPos?: string | number;
    hideRectangle?: boolean;
  }) => {
    const {
      width = 191,
      height = 149,
      containerStyle,
      number,
      numberFontSize = 26,
      topNumberPos = 57,
      hideRectangle = false,
    } = props;

    return (
      <View style={[{ width, height }, containerStyle]}>
        {/* SVG badge */}
        <Svg width={width} height={height} viewBox="0 0 191 149" fill="none">
          {!hideRectangle && (
            <Rect x="0.398438" y="38" width="190" height="111" rx="16" fill="#FEDD88" />
          )}
          <G clipPath="url(#clip0_3390_33213)">
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M62.5866 0H129.105L129.052 0.0930176L146.888 22.2932L122.283 63.6447C128.439 70.373 132.188 79.251 132.188 88.9972C132.188 109.988 114.806 127 93.3587 127C71.9112 127 54.5292 109.988 54.5292 88.9972C54.5292 77.6593 59.6087 67.4791 67.6555 60.5234L44.8984 22.2932L62.6816 0.155029L62.5866 0ZM101.923 51.9245L128.281 1.33325L116.802 19.7611H74.8469L63.9911 2.26343L89.4832 51.1803C90.761 51.0563 92.0493 50.9943 93.3587 50.9943C96.305 50.9943 99.1668 51.3147 101.923 51.9245ZM93.3587 58.9938C110.287 58.9938 124.015 72.4194 124.015 88.9972C124.015 105.575 110.287 119 93.3587 119C76.4309 119 62.7028 105.565 62.7028 88.9972C62.7028 72.4194 76.4309 58.9938 93.3587 58.9938Z"
              fill="black"
            />
            <G filter="url(#filter0_i_3390_33213)">
              <Ellipse cx="93.6235" cy="87.8992" rx="34.8549" ry="34.6453" fill="#D0651B" />
            </G>
            <Path
              d="M93.623 50.7539C114.239 50.7539 130.979 67.3704 130.979 87.8994C130.978 108.428 114.239 125.045 93.623 125.045C73.007 125.045 56.2687 108.428 56.2686 87.8994C56.2686 67.3706 73.0069 50.7541 93.623 50.7539Z"
              stroke="url(#paint0_linear_3390_33213)"
              strokeWidth="5"
            />
            <Path
              d="M77.6919 102.211H73.9284V92.0291H77.6869C78.7243 92.0291 79.6175 92.233 80.3666 92.6406C81.119 93.045 81.699 93.6283 82.1066 94.3906C82.5143 95.1496 82.7182 96.0578 82.7182 97.1151C82.7182 98.1757 82.5143 99.0871 82.1066 99.8494C81.7023 100.612 81.1239 101.197 80.3716 101.604C79.6192 102.009 78.726 102.211 77.6919 102.211ZM76.3893 100.113H77.5974C78.1675 100.113 78.6497 100.017 79.0441 99.8246C79.4419 99.629 79.7418 99.3125 79.944 98.875C80.1495 98.4342 80.2522 97.8475 80.2522 97.1151C80.2522 96.3826 80.1495 95.7992 79.944 95.3651C79.7385 94.9276 79.4352 94.6127 79.0342 94.4205C78.6365 94.2249 78.1459 94.1271 77.5626 94.1271H76.3893V100.113ZM85.7558 102.211H83.1109L86.5463 92.0291H89.8226L93.2579 102.211H90.613L88.2217 94.5945H88.1422L85.7558 102.211ZM85.4028 98.2038H90.9312V100.073H85.4028V98.2038ZM92.808 92.0291H95.5573L97.71 96.2898H97.7995L99.9522 92.0291H102.701L98.9777 98.8104V102.211H96.5317V98.8104L92.808 92.0291ZM109.237 95.0817C109.203 94.7171 109.056 94.4337 108.794 94.2315C108.536 94.026 108.166 93.9233 107.685 93.9233C107.367 93.9233 107.102 93.9647 106.89 94.0476C106.678 94.1304 106.519 94.2448 106.413 94.3906C106.307 94.5331 106.252 94.6972 106.249 94.8828C106.242 95.0353 106.272 95.1695 106.338 95.2855C106.408 95.4015 106.507 95.5043 106.636 95.5938C106.769 95.6799 106.928 95.7562 107.114 95.8224C107.299 95.8887 107.508 95.9467 107.74 95.9964L108.615 96.1953C109.119 96.3047 109.563 96.4505 109.948 96.6328C110.335 96.8151 110.66 97.0322 110.922 97.2841C111.187 97.536 111.388 97.826 111.524 98.1541C111.659 98.4822 111.729 98.8501 111.732 99.2578C111.729 99.9008 111.567 100.453 111.245 100.913C110.924 101.374 110.461 101.727 109.858 101.972C109.258 102.218 108.534 102.34 107.685 102.34C106.834 102.34 106.091 102.213 105.458 101.957C104.825 101.702 104.333 101.314 103.982 100.794C103.63 100.274 103.45 99.6158 103.44 98.8203H105.796C105.816 99.1484 105.904 99.4219 106.06 99.6406C106.216 99.8594 106.429 100.025 106.701 100.138C106.976 100.25 107.294 100.307 107.656 100.307C107.987 100.307 108.269 100.262 108.501 100.173C108.736 100.083 108.917 99.9588 109.043 99.7997C109.169 99.6406 109.233 99.4583 109.237 99.2528C109.233 99.0606 109.174 98.8965 109.058 98.7607C108.942 98.6214 108.763 98.5021 108.521 98.4027C108.282 98.3 107.977 98.2055 107.606 98.1193L106.542 97.8707C105.66 97.6686 104.966 97.3421 104.459 96.8913C103.952 96.4373 103.7 95.8241 103.703 95.0518C103.7 94.4221 103.869 93.8703 104.21 93.3963C104.552 92.9223 105.024 92.5528 105.627 92.2876C106.23 92.0225 106.918 91.8899 107.69 91.8899C108.479 91.8899 109.164 92.0241 109.744 92.2926C110.327 92.5578 110.779 92.9306 111.101 93.4112C111.422 93.8918 111.587 94.4486 111.593 95.0817H109.237Z"
              fill="white"
            />

            <G clipPath="url(#clip1_3390_33213)">
              <Ellipse cx="124.1" cy="112.15" rx="7.11111" ry="9.89567" fill="#FB7D24" />
              <Path
                d="M135.441 107.154C132.463 99.4636 121.863 99.049 124.423 87.8716C124.613 87.0422 123.721 86.4014 123.001 86.8349C116.117 90.8685 111.168 98.9547 115.321 109.548C115.662 110.415 114.638 111.225 113.899 110.66C110.466 108.078 110.106 104.364 110.409 101.707C110.523 100.727 109.234 100.255 108.684 101.066C107.394 103.026 106.086 106.193 106.086 110.961C106.807 121.517 115.776 124.759 119 125.174C123.608 125.758 128.595 124.91 132.179 121.649C136.123 118.011 137.564 112.206 135.441 107.154ZM117.843 116.635C120.574 115.975 121.977 114.015 122.356 112.281C122.982 109.586 120.536 106.947 122.185 102.687C122.811 106.212 128.386 108.417 128.386 112.262C128.538 117.031 123.342 121.121 117.843 116.635Z"
                fill="#FFC442"
              />
            </G>
          </G>
          <Defs>
            <LinearGradient
              id="paint0_linear_3390_33213"
              x1="93.6235"
              y1="53.2539"
              x2="93.6235"
              y2="122.544"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stopColor="#FF9900" />
            </LinearGradient>
            <ClipPath id="clip0_3390_33213">
              <Rect width="102" height="127" fill="white" transform="translate(44.8984)" />
            </ClipPath>
            <ClipPath id="clip1_3390_33213">
              <Rect
                width="45.5111"
                height="45.2374"
                fill="white"
                transform="translate(98.501 83.875)"
              />
            </ClipPath>
          </Defs>
        </Svg>

        {/* Number overlay */}
        {number !== undefined && (
          <Text style={[styles.number, { fontSize: numberFontSize, top: topNumberPos }]}>
            {number}
          </Text>
        )}
      </View>
    );
  },
);

const styles = StyleSheet.create({
  number: {
    position: 'absolute',
    left: 0,
    right: 0,
    textAlign: 'center',
    fontWeight: '400',
    color: '#ffffff',
    fontFamily: 'Secular One',
  },
});

export { StreakBadge };
